import * as React from 'react';
import IBrokerListAgent from './IBrokerListAgent';
import { Translate } from '../../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../../components/common/DeleteButton';

interface BrokerListRowProps {
    BrokerListAgent: IBrokerListAgent;
    key: number;
    delete: (id: number) => void;
    restore: (id: number) => void;
    edit: (agent: IBrokerListAgent) => void;
    currentUserId: number;
}

const BrokerAgentListRow = (props: BrokerListRowProps) => {
    return (
        <tr>
            <td>{props.BrokerListAgent.name}</td>
            <td>{props.BrokerListAgent.parentFirmName}</td>
            <td>
                {props.BrokerListAgent.isRemoved ? <i className="material-icons">check</i> : ''}
            </td>
            <td>
                <ButtonToolbar className="btn-group-sm pull-right">
                    <Button
                        onClick={() => {
                            props.edit(props.BrokerListAgent);
                        }}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('brokers/list/row/button-label/edit')}
                    </Button>
                    {props.currentUserId !== props.BrokerListAgent.id &&
                        !props.BrokerListAgent.isRemoved && (
                            <DeleteButton
                                onDelete={() => {
                                    props.delete(props.BrokerListAgent.id);
                                }}
                                text={Translate('brokers/list/row/delete/remove-this-broker-text')}
                            >
                                <i className="material-icons">delete</i>{' '}
                                {Translate('brokers/list/row/button-label/delete')}
                            </DeleteButton>
                        )}
                    {props.BrokerListAgent.isRemoved && (
                        <Button
                            onClick={() => {
                                props.restore(props.BrokerListAgent.id);
                            }}
                            bsStyle="primary"
                        >
                            <i className="material-icons">restore</i>{' '}
                            {Translate('brokers/list/row/button-label/restore')}
                        </Button>
                    )}
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default BrokerAgentListRow;
